import React from 'react';
import Trane_Logo_Red  from 'Assets/images/Trane_Logo_Red.png';
// eslint-disable-next-line
import { resourceData } from '../../../../Resources/Common/Common.en-US'

export default function FooterPane(){
    return(
        <div className="ServiceRequest_footer_container">
            <hr className='ServiceRequest_footer_line'/>
            <div style={{float:'left'}} className="ServiceRequest_footer_text">
               <span>
                   {(resourceData !== null && resourceData["footer.copyright.Text"] !== undefined) ? resourceData["footer.copyright.Text"]+" Technologies" : "©2023 Trane Technologies"}
                </span>
               <span>{"    |    "}</span>
               <a href="https://www.tranetechnologies.com/en/index/privacy-policy.html" target={"_blank"} rel="noopener noreferrer">
                <span className='ServiceRequest_footer_link' id="ServiceRequestPrivacyPolicy">
                    {(resourceData !== null && resourceData["footer.PrivacyPolicy.Text"] !== undefined) ? resourceData["footer.PrivacyPolicy.Text"] : "Privacy Policy"}
                </span>
               </a>
               <span>{"    |    "}</span>
               <a href="https://www.tranetechnologies.com/en/index/terms-of-use.html" target={"_blank"} rel="noopener noreferrer">
                <span className='ServiceRequest_footer_link' id="ServiceRequestEULA">
                    {(resourceData !== null && resourceData["footer.TermsOfUse.Text"] !== undefined) ? resourceData["footer.TermsOfUse.Text"] : "Terms of Use"}
                </span>
               </a>
            </div>
            <div className='ServiceRequest_footer_logo'>
                <img src={Trane_Logo_Red} alt="Trane_Red_Logo" style={{height:'43.37px',width:'126px'}}/>
            </div>
        </div>
    )
}